export const moduleName = 'chats'
